export default "__VITE_ASSET__e09abe53__"